import React from "react";
import { useSelector } from "react-redux";
import { FormatMoneyNumber } from "utils/numberUtils";
import { selectState } from "../accountReceivable.slice";

const TableFooter = () => {
  const {
    receivablesTotalInvoicedAmountForPartner,
    receivablesTotalDebtAmountForPartner,
    receivablesTotalPaidAmountForPartner,
    receivablesTotalCashPaidAmountForPartner,
  } = useSelector(selectState);
  return (
    <table className="table-footer">
      <colgroup>
        <col className="w4" />
        <col className="w10" />
        <col className="w23" />
        <col className="w10" />
        <col className="w10" />
        <col className="w15" />
        <col className="w10" />
        <col className="w10" />
        <col className="w4" />
        <col className="w4" />
      </colgroup>
      <tfoot>
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td className="right">
            <b>Ukupno:</b>
          </td>
          <td>
            <span className="total-value">
              {FormatMoneyNumber(receivablesTotalInvoicedAmountForPartner)}
            </span>
          </td>
          <td>
            <span className="total-value">
              {FormatMoneyNumber(receivablesTotalDebtAmountForPartner)}
            </span>
          </td>
          <td>
            <span className="total-value">
              {FormatMoneyNumber(receivablesTotalPaidAmountForPartner)}
            </span>
          </td>
          <td />
          <td />
        </tr>
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td className="right">
            <b>Ukupno keš:</b>
          </td>
          <td></td>
          <td></td>
          <td>
            <span className="total-value">
              {FormatMoneyNumber(receivablesTotalCashPaidAmountForPartner)}
            </span>
          </td>
          <td />
          <td />
        </tr>
      </tfoot>
    </table>
  );
};

export default TableFooter;
